import styled from "styled-components"

export const ToggleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: .5rem;
`
export const ToggleButton = styled.button`
  width: 120px;
  height: 44px;
  color: #496072;
  background-color: #ffffff;
  border: solid 1px #c5d0e1;
  font-size: 14px;
  font-weight: var(--font-weight-semibold);

  &:disabled {
    opacity: .5;
    cursor: not-allowed;
  }
`
export const ToggleLabel = styled.span`
  position:absolute;
  margin-bottom: 65px;
  line-height: 1.8rem;
  font-size: 12px;
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  color: var(--color-contrast-brand);
`
